import script from "./GridLegalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridLegalComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridLegalComponent.vue?vue&type=style&index=0&id=d2f2889c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2f2889c"]])

export default __exports__